<template>
  <div>
    <Head title="Create Inventory UIDs" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-orange-400 hover:text-orange-600" href="/sku-items/">SKU Items</Link>
      <span class="text-orange-400 font-medium">/</span> Create
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <div class="pb-2 pr-6 w-full lg:w-1/2">
            <p class="mb-2">Pieces:</p>
            <text-input
              v-model="form.quantity"
              :error="form.errors.quantity"
              placeholder="Pieces"
              class="pb-2"
            />
          </div>
          <div class="pb-8 pr-6 w w-full lg:w-1/2">
            <p class="mb-2">SKU:</p>
            <multiselect
              id="part_number"
              v-model="selectedSku"
              placeholder="Search SKU"
              :options="skus"
              :close-on-select="true"
              :searchable="true"
              :error="form.errors.part_number"
              :style="form.errors.part_number ? 'border: var(--ms-border-width,1px) solid var(--ms-border-color,red)' : ''"
              @search-change="onSearchSkusChange"
              @input="onSelectedSku"
            />
            <div v-if="form.errors.part_number" class="form-error">{{ form.errors.part_number }}</div>
          </div>
          <div class="pb-8 pr-6 w w-full lg:w-1/2">
            <p class="mb-2">Purchase Order Number:</p>
            <multiselect
              id="PO_number"
              v-model="selectedPO"
              placeholder="Search PO Number"
              :options="poNumbers"
              :close-on-select="true"
              :searchable="true"
              :error="form.errors.PO_number"
              :style="form.errors.PO_number ? 'border: var(--ms-border-width,1px) solid var(--ms-border-color,red)' : ''"
              @search-change="onSearchPOChange"
              @input="onSelectedPO"
            />
            <div v-if="form.errors.PO_number" class="form-error">{{ form.errors.PO_number }}</div>
          </div>
          <div class="pb-2 pr-6 w-full lg:w-1/3 hidden">
            <text-input
              v-model="form.PO_number"
              :error="form.errors.PO_number"
              placeholder="PO Number"
              class="pb-2"
              @keyup="checkPONumber"
            />
            <span
              v-if="poNumberSearching && form.PO_number !== '' && poNumberObj.message !='' && !form.errors.PO_number"
              class="mt-3"
            >
              <span class="form-error">{{ poNumberObj.message }}</span>
            </span>
            <span v-else />
          </div>
          <div class="pb-8 pr-6 w w-full lg:w-1/2">
            <p class="mb-2">GRN/Container Number:</p>
            <text-input
              v-model="form.GRN_number"
              :error="form.errors.GRN_number"
              class="pb-8 pr-6"
              placeholder="GRN/Container Number"
            />
          </div>
          <div
            v-for="(item, windex) in form.items"
            :key="windex"
            class="grid grid-cols-3 hidden"
          >
            <div class="pb-2 pr-6 w-full lg:w-full">
              <text-input
                :key="windex"
                v-model="item.part_number"
                class="pb-2"
                :error="form.errors.part_number"
                placeholder="Part Number"
              />
              <span
                v-if="isValidationErrors(`items.${windex}.part_number`)"
                class="mt-3"
              >
                <span class="form-error">{{ showValidationErrors(`items.${windex}.part_number`) }}</span>
              </span>
              <text-input
                :key="windex"
                v-model="item.sku_id"
                class="hidden"
                :error="form.errors.sku_id"
              />
            </div>
            <div class="pb-2 pr-6 w-full lg:w-full">
              <text-input
                :key="windex"
                v-model="item.description"
                class="pb-2"
                :error="form.errors.description"
                placeholder="Description"
              />
              <span
                v-if="isValidationErrors(`items.${windex}.description`)"
                class="mt-3"
              >
                <span class="form-error">{{ showValidationErrors(`items.${windex}.description`) }}</span>
              </span>
            </div>
            <div class="pb-2 pr-6 w-full lg:w-full">
              <text-input
                :key="windex"
                v-model="item.unit"
                class="pb-2"
                :error="form.errors.unit"
                placeholder="Units"
              />
              <span
                v-if="isValidationErrors(`items.${windex}.unit`)"
                class="mt-3"
              >
                <span class="form-error">{{ showValidationErrors(`items.${windex}.unit`) }}</span>
              </span>
            </div>
          </div>
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-orange" type="submit">Generate UIDs</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import axios from 'axios'
import Multiselect from '@vueform/multiselect'
import throttle from 'lodash/throttle'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    TextInput,
    Multiselect,
  },
  layout: Layout,
  props: {
    skus: Object,
    poNumbers: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        items:[{
          part_number: null,
          unit: null,
          description: null,
          sku_id: null,
          
        }],
        // PO_number: '',
        GRN_number: '',
        quantity: null,
        PO_number: '',
        part_number: null,
      }),      
      poNumberObj: [],
      poNumberSearching: false,
      selectedSku: null,
      selectedPO: null,
    }
  },
  methods: {
    store() {
      this.form.post('/items/inventories/generate-uids', {
        onSuccess: () => {
          this.form.reset('items', 'PO_number', 'GRN_number'),
          window.location.href = '/item-downloads'
        },
      })
      
    },
    isValidationErrors(value) {
      if (this.form.errors) {
        const error = this.form.errors[value] || ''
        return !!error
      }
      return false
    },
    showValidationErrors(value) {
      if (this.form.errors) {
        const error = this.form.errors[value] || ''
        return error || ''
      }
      return ''
    },
    checkPONumber() {
      this.poNumberSearching = true
      if (this.form.PO_number) {
        axios.get(`/items/purchaseOrders/${this.form.PO_number}/search`).then(response => {
          this.poNumberObj = response.data
          this.form.items = response.data
        })
      }
    },
    onSearchSkusChange: throttle(function (search) {
      this.$inertia.get('/items/inventories/generate-uids/create', {search}, {
        preserveState: true,
        preserveScroll: true,
        replace: true,
      })
    }, 200),
    onSelectedSku(part_number, id) {
      this.form.part_number = part_number
    },
    onSearchPOChange: throttle(function (search) {
      this.$inertia.get('/items/inventories/generate-uids/create', {search}, {
        preserveState: true,
        preserveScroll: true,
        replace: true,
      })
    }, 200),
    onSelectedPO(PO_number, id) {
      this.form.PO_number = PO_number
    },
  },
}
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
<style type="text/css">
  .multiselect-option.is-selected.is-pointed {
    background: var(--ms-option-bg-selected-pointed,#fb923c);
    color: var(--ms-option-color-selected-pointed,#fff);
  }
  .multiselect-option.is-selected {
    background: var(--ms-option-bg-selected-pointed,#fb923c);
    color: var(--ms-option-color-selected-pointed,#fff);
  }
</style>
